import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {DevicesService} from '../../../services/devices.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, concatMap, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { DeviceSettingActions } from '../actions/device-setting.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class DeviceSettingEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceService = inject(DevicesService);
  private injector = inject(Injector);


  constructor() {}

  UpdateDeviceSetting$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.DeviceSettingActionTypes.UpdateDeviceSetting),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateDeviceSetting
      };
      const payload = { ...action.payload, otp: user.otp };
      return this.deviceService.UpdateDeviceSetting(payload).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: this.injector.get(TranslateService).instant('Update Device Setting Success'), result: true })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.UpdateDevicesSettingFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.UpdateDevicesSettingFail()];
        })
      );
    })
  ));
}
